import apiClient from './client';
import type {
    AdUnitResponse, AvailableOptionsResponse, ComparisonRequest, ComparisonResponse,
    DashboardFilters
} from '@/types/analytics';
import type {
    CustomReportParams,
    CustomReportResponse
} from '@/types/reports';
import { getSelectedNetwork } from '@/lib/gamNetwork';

// Todo relatório vai com a conta GAM do seletor. A API cruza com os domínios
// daquela conta antes do escopo do gestor; sem `network`, soma todas as contas.
const comConta = <T extends object>(dados: T): T & { network?: string } => {
    const network = getSelectedNetwork();
    return network ? { ...dados, network } : dados;
};

// ========== DASHBOARD ANALYTICS API ==========

// Obter dados de Ad Unit (Receita Geral)
export const getAdUnitData = async (filters: Partial<DashboardFilters>): Promise<AdUnitResponse> => {
    const response = await apiClient.get<AdUnitResponse>('/reports/dashboard', { params: comConta(filters) });
    return response.data;
};

export const getCustomReport = async (params: CustomReportParams): Promise<CustomReportResponse> => {
    const response = await apiClient.post<CustomReportResponse>('/reports/custom', comConta(params));
    return response.data;
};


export const getAvailableOptions = async (
    start: string,
    end: string,
    domains?: string[],
    country?: string
): Promise<AvailableOptionsResponse> => {
    const params = new URLSearchParams({
        start,
        end,
    });

    const network = getSelectedNetwork();
    if (network) {
        params.append('network', network);
    }

    if (country) {
        params.append('country', country);
    }

    if (domains && domains.length > 0) {
        domains.forEach(domain => params.append('domains[]', domain));
    }

    const response = await apiClient.get<AvailableOptionsResponse>(
        `/reports/key-values/available-options?${params.toString()}`
    );

    return response.data;
};

// Comparação entre custom_values
export const compareValues = async (
    request: ComparisonRequest
): Promise<ComparisonResponse> => {
    const response = await apiClient.post<ComparisonResponse>(
        '/reports/key-values/compare-values',
        comConta(request)
    );
    return response.data;
};

// Relatório multidimensional flexível
export const generateKeyValuesReport = async (
    request: any
): Promise<any> => {
    const response = await apiClient.post(
        '/reports/key-values/generate',
        comConta(request)
    );
    return response.data;
};

// Análise de séries temporais
export const getKeyValuesTimeSeries = async (
    request: any
): Promise<any> => {
    const response = await apiClient.post(
        '/reports/key-values/time-series',
        comConta(request)
    );
    return response.data;
};
